import {
  ConstructionRounded as InstallersIcon,
  DashboardOutlined as DashboardsIcon,
  GroupsOutlined as UsersIcon,
  House as PropertiesIcon,
  PendingActions as ScheduledReportsIcon,
  PublicRounded as OrganizationsIcon,
  ScienceRounded as DataScienceIcon,
  SensorsRounded as DevicesIcon,
  ViewModuleRounded as UnitsIcon,
  WorkspacesRounded as AccountsIcon,
} from '@mui/icons-material'

import { ShipBob as ShipBobIcon } from '@common/icons'
import accountUrls from '@portal/pages/Accounts/urls'
import clientMapUrls from '@portal/pages/Dashboards/ClientMap/urls'
import eventUrls from '@portal/pages/Dashboards/Events/urls'
import financeUrls from '@portal/pages/Dashboards/Finance/urls'
import issuesUrls from '@portal/pages/Dashboards/Issues/urls'
import liveMetricsUrls from '@portal/pages/Dashboards/LiveMetrics/urls'
import reviewAnalysisUrls from '@portal/pages/Dashboards/ReviewAnalysis/urls'
import scoreboardsUrls from '@portal/pages/Dashboards/Scoreboards/urls'
import metricUrls from '@portal/pages/Dashboards/SmokeMetrics/urls'
import propertySmokeProfilesUrls from '@portal/pages/DataScience/PropertySmokeProfiles/urls'
import scenarioUrls from '@portal/pages/DataScience/Scenarios/urls'
import sensorTestingUrls from '@portal/pages/DataScience/SensorTesting/urls'
import smokeProfileEnsemblesUrls from '@portal/pages/DataScience/SmokeProfileEnsembles/urls'
import smokeProfilesUrls from '@portal/pages/DataScience/SmokeProfiles/urls'
import deviceUrls from '@portal/pages/Devices/urls'
import installersUrls from '@portal/pages/Installers/urls'
import orgUrls from '@portal/pages/Organizations/urls'
import propertyUrls from '@portal/pages/Properties/urls'
import scheduledReportPrefUrls from '@portal/pages/ScheduledReportPreferences/urls'
import shipbobOrdersUrls from '@portal/pages/ShipbobOrders/urls'
import unitUrls from '@portal/pages/Units/urls'
import userUrls from '@portal/pages/Users/urls'

/**
 * @function
 * @param {Object} props - The props for the function.
 * @param {Object} props.routes
 * @param {string[]} props.portalRoles
 */
export default function getSidebarEntries({ routes, portalRoles }) {
  return [
    {
      icon: InstallersIcon,
      label: 'Installers',
      href: installersUrls.list,
      allowedRoles: ['INSTALLER'],
    },
    {
      icon: DashboardsIcon,
      label: 'Dashboards',
      subitems: [
        {
          label: 'Issues',
          href: issuesUrls.list,
        },
        {
          label: 'Events',
          href: eventUrls.list,
        },
        {
          label: 'Metrics',
          href: metricUrls.metrics,
        },
        {
          label: 'Live Metrics',
          href: liveMetricsUrls.metrics,
        },
        {
          label: 'Review Analysis',
          href: reviewAnalysisUrls.dashboard,
        },
        {
          label: 'Property Scoreboard',
          href: scoreboardsUrls.property,
        },
        {
          label: 'Company Scoreboard',
          href: scoreboardsUrls.company,
        },
        {
          label: 'Client Map',
          href: clientMapUrls.map,
        },
        {
          label: 'Finance',
          href: financeUrls.dashboard,
        },
      ],
    },
    {
      icon: UsersIcon,
      label: 'Users',
      href: userUrls.list,
    },
    {
      icon: OrganizationsIcon,
      label: 'Organizations',
      href: orgUrls.list,
    },
    {
      icon: AccountsIcon,
      label: 'Accounts',
      href: accountUrls.list,
    },
    {
      icon: PropertiesIcon,
      label: 'Properties',
      href: propertyUrls.list,
    },
    {
      icon: UnitsIcon,
      label: 'Units',
      href: unitUrls.list,
    },
    {
      icon: DevicesIcon,
      label: 'Devices',
      href: deviceUrls.list,
    },
    {
      icon: ScheduledReportsIcon,
      label: 'Scheduled Reports',
      href: scheduledReportPrefUrls.list,
    },
    {
      icon: DataScienceIcon,
      label: 'Data Science',
      subitems: [
        {
          label: 'Ensembles List',
          href: smokeProfileEnsemblesUrls.list,
        },
        {
          label: 'Profiles List',
          href: smokeProfilesUrls.list,
        },
        {
          label: 'Properties List',
          href: propertySmokeProfilesUrls.list,
        },
        {
          label: 'Scenarios',
          href: scenarioUrls.list,
        },
        {
          label: 'Sensor Testing',
          href: sensorTestingUrls.testing,
        },
      ],
    },
    {
      icon: ShipBobIcon,
      label: 'ShipBob Orders',
      href: shipbobOrdersUrls.list,
      hidden: true,
    },
  ].map((option) => {
    if (option.subitems) {
      return {
        ...option,
        subitems: option.subitems.map((subitem) => ({
          ...subitem,
          allowedRoles:
            subitem.allowedRoles ?? routes[subitem.href]?.allowedRoles ?? portalRoles,
        })),
      }
    }
    return {
      ...option,
      allowedRoles:
        option.allowedRoles ?? routes[option.href].allowedRoles ?? portalRoles,
    }
  })
}
